import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreTypes } from 'mbs-ui-shared@store/storeTypes.enum';
import { ScriptLibraryService } from 'wizards/services/script-library.service';
import { ScriptLibraryEffects } from './effects';
import { reducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [StoreModule.forFeature(StoreTypes.RmmScriptLibrary, reducer), EffectsModule.forFeature([ScriptLibraryEffects])],
  providers: [ScriptLibraryService]
})
export class RmmScriptLibraryStoreModule {}
